export const ecosystemOptions = [
  "Coastal",
  "Desert",
  "Farmland",
  "Forests",
  "Freshwater",
  "Grassland",
  "Marine",
  "Peatland",
];

export const actionOptions = ["Protection", "Regeneration", "Restoration"];
